class RequestError extends Error {
  constructor(message, status, body = null, json = null) {
    super(message);
    this.name = 'RequestError';
    this.message = message;
    this.status = status;
    try {
      this.body = body ? JSON.parse(body) : null;
    } catch (e) {
      this.body = body ? { message: body } : null;
    }
    this.json = json;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }
}

export default RequestError;
